import { decodeAbiParameters } from "viem";

import { Loan } from "../../data/types";

import { calcPaymentSchedule, type PaymentScheduleResult, type ScheduleTerms } from "./paymentSchedule";

const irmOptionsAbi = [
  { name: "principalAndInterestStubPayment", type: "bool" },
  { name: "gracePeriodDuration", type: "uint64" },
  { name: "gracePeriodRate", type: "uint256" },
] as const;

function toScheduleTerms(loan: Loan): ScheduleTerms {
  const { repaymentSpec, interestRateSpec, trancheSpecs } = loan.termsStruct;
  const [principalAndInterestStubPayment] = decodeAbiParameters(irmOptionsAbi, interestRateSpec.options);

  return {
    chain: loan.chainId,
    repaymentDay: repaymentSpec.day,
    totalDurationDays: repaymentSpec.totalDurationDays,
    timezoneOffsetSeconds: repaymentSpec.timezoneOffsetSeconds,
    interestRateModel: interestRateSpec.model,
    principalAndInterestStubPayment,
    trancheSpecs,
    feeSpecs: loan.termsStruct.feeSpecs.map((s) => ({
      kind: s.kind,
      model: s.model,
      options: s.options,
    })),
  };
}

export function calcLoanPaymentSchedule(loan: Loan, scaledBalanceOverride?: bigint): PaymentScheduleResult {
  const terms = toScheduleTerms(loan);
  const { repaymentCount, originationTimestamp, scaledBalance } = loan.loanState;

  return calcPaymentSchedule(terms, {
    originationTimestamp,
    repaymentCount,
    scaledBalance: scaledBalanceOverride ?? scaledBalance,
    currencyDecimals: loan.erc20.decimals,
  });
}
